var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 32H64C28.654 32 0 60.652 0 96V416C0 451.344 28.654 480 64 480H384C419.346 480 448 451.344 448 416V96C448 60.652 419.346 32 384 32ZM369.283 231.168L309.709 289.1L323.797 370.934C326.332 385.734 310.73 396.754 297.646 389.891L224 351.248L150.354 389.891C137.27 396.807 121.668 385.734 124.203 370.934L138.291 289.1L78.717 231.168C68.01 220.764 73.926 202.598 88.701 200.463L171.029 188.484L207.834 114.016C214.473 100.578 233.58 100.744 240.166 114.016L276.971 188.484L359.299 200.463C374.074 202.598 379.99 220.764 369.283 231.168Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareStar);
export default __webpack_public_path__ + "static/media/square-star.0ee4549a7256a018ce4db777baa29cdf.svg";
export { ForwardRef as ReactComponent };